/**
 * Format a sorted array of numbers into a compact string representation.
 * Consecutive sequences are represented as a range (e.g., "1-3"),
 * while non-consecutive numbers are listed individually (e.g., "1, 3, 5").
 *
 * @param {number[]} nums - A sorted array of numbers to compress.
 * @returns {string} A compressed string representation of the number sequence.
 *
 * @example
 * formatNumberRanges([1, 3, 4, 5, 7, 9, 10, 11]) // "1, 3-5, 7, 9-11"
 * formatNumberRanges([1, 3, 5, 7, 9]) // "1, 3, 5, 7, 9"
 * formatNumberRanges([]) // ""
 */
export const formatNumberRanges = (nums: number[]): string => {
  if (nums.length === 0) return ''

  const result: string[] = []

  let [start] = nums
  let [end] = nums

  nums.forEach((num, index) => {
    const nextNumInArray = nums[index + 1]

    if (nextNumInArray === num + 1) {
      end = nextNumInArray
    } else {
      result.push(start === end ? `${start}` : `${start}-${end}`)
      start = nextNumInArray
      end = nextNumInArray
    }
  })

  return result.join(', ')
}
